import { RoundToTwoDecimalPlaces } from "../../../utils/numberUtils";

export const makeZeroIfNotNumber = (n) => Number.isFinite(n) ? n : 0;

export const itemStats = (items, year) => {
        const getValue = (item, field) => {
            const sourceOfValue = year ? item.statsByYear?.[year] : item;
            return makeZeroIfNotNumber(sourceOfValue?.[field])
        }
        const internalItems = items.filter(i => i.isInternal);
        const externalItems = items.filter(i => !i.isInternal);

        // Upfront stats.  This may be for the whole term, of just for a single year.  This depends on the "year" parameter passed in.
        // Note that upfront costs and prices are only ever in year 1, so if year > 1, these will be zero.
        const totalInternalUpfrontCost = internalItems.reduce((sum, item) => sum + getValue(item, "totalUpfrontCost"), 0)
        const totalExternalUpfrontCost = externalItems.reduce((sum, item) => sum + getValue(item, "totalUpfrontCost"), 0)
        const totalUpfrontCost = totalInternalUpfrontCost + totalExternalUpfrontCost
        const totalUpfrontPrice = RoundToTwoDecimalPlaces(items.reduce((sum, item) => sum + getValue(item, "totalUpfrontPrice"), 0))
        const totalUpfrontMargin = RoundToTwoDecimalPlaces(totalUpfrontPrice - totalUpfrontCost)
        const totalUpfrontMarginPercentage = totalUpfrontPrice > 0 ? RoundToTwoDecimalPlaces((totalUpfrontMargin / totalUpfrontPrice) * 100) : 0;
        const totalUpfrontRLEC = RoundToTwoDecimalPlaces(totalUpfrontPrice - totalExternalUpfrontCost);
        const totalUpfrontRLECPercentage = totalUpfrontPrice > 0 ? RoundToTwoDecimalPlaces((totalUpfrontRLEC / totalUpfrontPrice) * 100) : 0;

        // Recurring stats.  This may be for the whole term, of just for a single year.  This depends on the "year" parameter passed in.
        const totalInternalRecurringCost = internalItems.reduce((sum, item) => sum + getValue(item, "totalRecurringCost"), 0)
        const totalExternalRecurringCost = externalItems.reduce((sum, item) => sum + getValue(item, "totalRecurringCost"), 0)
        const totalRecurringCost = totalInternalRecurringCost + totalExternalRecurringCost
        const totalRecurringPrice = RoundToTwoDecimalPlaces(items.reduce((sum, item) => sum + getValue(item, "totalRecurringPrice"), 0))
        const totalRecurringMargin = RoundToTwoDecimalPlaces(totalRecurringPrice - totalRecurringCost)
        const totalRecurringMarginPercentage = totalRecurringPrice > 0 ? RoundToTwoDecimalPlaces((totalRecurringMargin / totalRecurringPrice) * 100) : 0;
        const totalRecurringRLEC = RoundToTwoDecimalPlaces(totalRecurringPrice - totalExternalRecurringCost);
        const totalRecurringRLECPercentage = totalRecurringPrice > 0 ? RoundToTwoDecimalPlaces((totalRecurringRLEC / totalRecurringPrice) * 100) : 0;

        // Combination of upfront and recurring stats.  This may be for the whole term, or just for a single year.  This depends on the "year" parameter passed in.
        const totalInternalUpfrontAndRecurringCost = totalInternalUpfrontCost + totalInternalRecurringCost;
        const totalExternalUpfrontAndRecurringCost = totalExternalUpfrontCost + totalExternalRecurringCost;
        const totalUpfrontAndRecurringCost = totalUpfrontCost + totalRecurringCost;
        const totalUpfrontAndRecurringPrice = totalUpfrontPrice + totalRecurringPrice;
        const totalUpfrontAndRecurringMargin = makeZeroIfNotNumber(totalUpfrontMargin) + makeZeroIfNotNumber(totalRecurringMargin);
        const totalUpfrontAndRecurringMarginPercentage = totalUpfrontAndRecurringPrice > 0 ? RoundToTwoDecimalPlaces((totalUpfrontAndRecurringMargin / totalUpfrontAndRecurringPrice) * 100) : 0;
        const totalUpfrontAndRecurringRLEC = RoundToTwoDecimalPlaces(totalUpfrontAndRecurringPrice - totalExternalUpfrontAndRecurringCost);
        const totalUpfrontAndRecurringRLECPercentage = totalUpfrontAndRecurringPrice > 0 ? RoundToTwoDecimalPlaces((totalUpfrontAndRecurringRLEC / totalUpfrontAndRecurringPrice) * 100) : 0;

        // Annual stats.  These figures are for 12 months of payments, or less if the contract term is shorter.
        const totalInternalAnnualCost = internalItems.reduce((sum, item) => sum + makeZeroIfNotNumber(item.totalAnnualCost), 0)
        const totalExternalAnnualCost = externalItems.reduce((sum, item) => sum + makeZeroIfNotNumber(item.totalAnnualCost), 0)
        const totalAnnualCost = totalInternalAnnualCost + totalExternalAnnualCost
        const totalAnnualPrice = RoundToTwoDecimalPlaces(items.reduce((sum, item) => sum + makeZeroIfNotNumber(item.totalAnnualPrice), 0))
        const totalAnnualMargin = RoundToTwoDecimalPlaces(totalAnnualPrice - totalAnnualCost)
        const totalAnnualMarginPercentage = totalAnnualPrice > 0 ? RoundToTwoDecimalPlaces((totalAnnualMargin / totalAnnualPrice) * 100) : 0;
        const totalAnnualRLEC = RoundToTwoDecimalPlaces(totalAnnualPrice - totalExternalAnnualCost);
        const totalAnnualRLECPercentage = totalAnnualPrice > 0 ? RoundToTwoDecimalPlaces((totalAnnualRLEC / totalAnnualPrice) * 100) : 0;

        // Contract stats.  These figures are for the whole term of the contract.
        const totalInternalContractCost = totalInternalUpfrontCost + totalInternalRecurringCost;
        const totalExternalContractCost = totalExternalUpfrontCost + totalExternalRecurringCost;
        const totalContractCost = items.reduce((sum, item) => sum + makeZeroIfNotNumber(item.totalContractCost), 0);
        const totalContractPrice = items.reduce((sum, item) => sum + makeZeroIfNotNumber(item.totalContractPrice), 0);
        const totalContractMargin = makeZeroIfNotNumber(totalUpfrontMargin) + makeZeroIfNotNumber(totalRecurringMargin);
        const totalContractMarginPercentage = totalContractPrice > 0 ? RoundToTwoDecimalPlaces((totalContractMargin / totalContractPrice) * 100) : 0;
        const totalContractRLEC = totalUpfrontRLEC + totalRecurringRLEC;
        const totalContractRLECPercentage = totalContractPrice > 0 ? RoundToTwoDecimalPlaces((totalContractRLEC / totalContractPrice) * 100) : 0;

    return ({
        // Upfront Stats
        totalInternalUpfrontCost,
        totalExternalUpfrontCost,
        totalUpfrontCost,
        totalUpfrontPrice,
        totalUpfrontMargin,
        totalUpfrontMarginPercentage,
        totalUpfrontRLEC,
        totalUpfrontRLECPercentage,

        //Returning Stats
        totalInternalRecurringCost,
        totalExternalRecurringCost,
        totalRecurringCost,
        totalRecurringPrice,
        totalRecurringMargin,
        totalRecurringMarginPercentage,
        totalRecurringRLEC,
        totalRecurringRLECPercentage,

        // Annual Stats
        totalInternalAnnualCost,
        totalExternalAnnualCost,
        totalAnnualCost,
        totalAnnualPrice,
        totalAnnualMargin,
        totalAnnualMarginPercentage,
        totalAnnualRLEC,
        totalAnnualRLECPercentage,

        // Full Term Contract Stats
        totalInternalContractCost,
        totalExternalContractCost,
        totalContractCost,
        totalContractPrice,
        totalContractMargin,
        totalContractMarginPercentage,
        totalContractRLEC,
        totalContractRLECPercentage,

        // Combined Upfront and Recurring Stats
        totalInternalUpfrontAndRecurringCost,
        totalExternalUpfrontAndRecurringCost,
        totalUpfrontAndRecurringCost,
        totalUpfrontAndRecurringPrice,
        totalUpfrontAndRecurringMargin,
        totalUpfrontAndRecurringMarginPercentage,
        totalUpfrontAndRecurringRLEC,
        totalUpfrontAndRecurringRLECPercentage
    });
}

export const getGroupedData = (items, groupBy1, groupBy2, groupBy3, year) => {
        const hasNonEmptySalesforceCode = (salesforceCode) =>
            salesforceCode !== null &&
            salesforceCode !== undefined &&
            String(salesforceCode).trim() !== "";

        const hasDifferentUpfrontAndRecurringSalesforceCodes = (item) =>
            item.isRecurring &&
            item.isUpfront &&
            item.upfrontSalesforceCode !== item.recurringSalesforceCode;

        const itemsWithOneSFCode = items
            .filter(x => !hasDifferentUpfrontAndRecurringSalesforceCodes(x))
            .map(item => ({ ...item, 
                salesforceCode: item.isUpfront 
                    ? item.upfrontSalesforceCode 
                    : item.isRecurring 
                        ? item.recurringSalesforceCode
                        : null,
                businessCOE: item.isUpfront
                    ? item.upfrontBusinessCOE
                    : item.isRecurring
                        ? item.recurringBusinessCOE
                        : null
                    })
            );

        const itemsWithDifferentUpfrontAndRecurringWithSFCodes = items
            .filter(x => hasDifferentUpfrontAndRecurringSalesforceCodes(x))

        const upfrontItemsThatHadDifferentSFCodeToRecurring = itemsWithDifferentUpfrontAndRecurringWithSFCodes.map(item => {
            const adjustedStatsByYear = item.statsByYear
                ? Object.fromEntries(
                    Object.entries(item.statsByYear).map(([yearKey, stats]) => {
                        const totalUpfrontCost = makeZeroIfNotNumber(stats.totalUpfrontCost);
                        const totalUpfrontPrice = makeZeroIfNotNumber(stats.totalUpfrontPrice);
                        const totalContractCost = totalUpfrontCost;
                        const totalContractPrice = totalUpfrontPrice;
                        const totalContractMargin = totalContractPrice - totalContractCost;
                        return [
                            yearKey,
                            {
                                ...stats,
                                // zero out recurring-related fields for upfront-only split
                                totalRecurringCost: 0,
                                totalRecurringPrice: 0,
                                totalRecurringMargin: 0,
                                totalRecurringRLEC: 0,
                                totalAnnualCost: 0,
                                totalAnnualPrice: 0,
                                recurringCost: 0,
                                recurringPrice: 0,    
                                annualCost: 0,
                                annualPrice: 0,
                                // contract stats should reflect upfront-only component
                                totalContractCost,
                                totalContractPrice,
                                totalContractMargin
                            }
                        ];
                    })
                )
                : item.statsByYear;
            return {
                ...item,
                salesforceCode: item.upfrontSalesforceCode ?? item.salesforceCode,
                businessCOE: item.upfrontBusinessCOE,
                isRecurring: false,
                recurringCost: 0,
                recurringPrice: 0,
                annualCost: 0,
                annualPrice: 0,
                totalRecurringPrice: 0,
                totalRecurringCost: 0,
                totalRecurringMargin: 0,
                totalRecurringRLEC: 0,
                totalAnnualCost: 0,
                totalAnnualPrice: 0,
                totalContractCost: item.totalUpfrontCost,
                totalContractPrice: item.totalUpfrontPrice,
                statsByYear: adjustedStatsByYear
            };
        });

        const recurringItemsThatHadDifferentSFCodeToUpfront = itemsWithDifferentUpfrontAndRecurringWithSFCodes.map(item => {
            const adjustedStatsByYear = item.statsByYear
                ? Object.fromEntries(
                    Object.entries(item.statsByYear).map(([yearKey, stats]) => {
                        const totalRecurringCost = makeZeroIfNotNumber(stats.totalRecurringCost);
                        const totalRecurringPrice = makeZeroIfNotNumber(stats.totalRecurringPrice);
                        const totalContractCost = totalRecurringCost;
                        const totalContractPrice = totalRecurringPrice;
                        const totalContractMargin = totalContractPrice - totalContractCost;
                        return [
                            yearKey,
                            {
                                ...stats,
                                // zero out upfront-related fields for recurring-only split
                                totalUpfrontCost: 0,
                                totalUpfrontPrice: 0,
                                totalUpfrontMargin: 0,
                                totalUpfrontRLEC: 0,
                                // contract stats should reflect recurring-only component
                                totalContractCost,
                                totalContractPrice,
                                totalContractMargin
                            }
                        ];
                    })
                )
                : item.statsByYear;
            return {
                ...item,
                salesforceCode: item.recurringSalesforceCode ?? item.salesforceCode,
                businessCOE: item.recurringBusinessCOE,
                isUpfront: false,
                upfrontCost: 0,
                upfrontPrice: 0,
                totalUpfrontPrice: 0,
                totalUpfrontCost: 0,
                totalUpfrontMargin: 0,
                totalUpfrontRLEC: 0,
                totalContractCost: item.totalRecurringCost,
                totalContractPrice: item.totalRecurringPrice,
                statsByYear: adjustedStatsByYear
            };
        });

        const itemsSplitBySFCode = [
            ...itemsWithOneSFCode,
            ...upfrontItemsThatHadDifferentSFCodeToRecurring,
            ...recurringItemsThatHadDifferentSFCodeToUpfront
        ];

        const uniqueCombinations = [
            ...new Set(
                itemsSplitBySFCode.map(item => {
                    const groupBy1Value = item[groupBy1] ?? "(Empty)";
                    const groupBy2Value = item[groupBy2] ?? "(Empty)";

                    if (groupBy3 === "None") {
                        return JSON.stringify({ groupBy1: groupBy1Value, groupBy2: groupBy2Value });
                    }

                    const groupBy3Value = item[groupBy3] ?? "(Empty)";

                    return JSON.stringify({ groupBy1: groupBy1Value, groupBy2: groupBy2Value, groupBy3: groupBy3Value });
                })
            )
        ].map(str => JSON.parse(str));

        const uniqueGroupBy1Values = [
            ...new Set(itemsSplitBySFCode.map(item => item[groupBy1] ?? "(Empty)"))
        ];



        const summaryData = uniqueCombinations.map(combination => {
            const itemsInCombination = itemsSplitBySFCode.filter(i =>
                (i[groupBy1] ?? "(Empty)") === combination["groupBy1"] &&
                (i[groupBy2] ?? "(Empty)") === combination["groupBy2"] &&
                (groupBy3 === "None" || (i[groupBy3] ?? "(Empty)") === combination["groupBy3"])
            );
            const filteredStats = itemStats(itemsInCombination, year);
            return {
                id: "summary_" + combination.groupBy1 + "_" + combination.groupBy2 + (groupBy3 !== "None" ? "_" + combination.groupBy3 : ""),
                ...combination,
                ...filteredStats
            };
        });

        const groupedStats = uniqueGroupBy1Values.map(groupBy1Value => {
            const itemsInGroup = itemsSplitBySFCode.filter(i => (i[groupBy1] ?? "(Empty)") === groupBy1Value);
            const filteredStats = itemStats(itemsInGroup, year);
            return ({
                groupBy1: groupBy1Value ?? "(Empty)",
                id: "group_" + groupBy1Value,
                ...filteredStats,
                items: summaryData.filter(i => i.groupBy1 === groupBy1Value)
                    .sort((a, b) => {
                        if (a.groupBy2 !== b.groupBy2) {
                            return a.groupBy2.localeCompare(b.groupBy2);
                        }
                        if (a.groupBy3 && b.groupBy3 && a.groupBy3 !== b.groupBy3) {
                            return a.groupBy3.localeCompare(b.groupBy3);
                        }
                        return 0;
                    })
            });
        }).sort((a, b) => {
            if (a.groupBy1 !== b.groupBy1) {
                return a.groupBy1.localeCompare(b.groupBy1);
            }
            return 0;
        });    
        
        return groupedStats
    }